export const NIM_CACHE_ID_PREFIX = 'nim';

const getNimCacheId = (nimServerId: string | number) => `${NIM_CACHE_ID_PREFIX}-${nimServerId}`;
export const nimCacheIdReg = new RegExp(`^${NIM_CACHE_ID_PREFIX}-[a-zA-z0-9]+$`);
export const isNimCacheId = (targetId?: string) =>
  targetId ? nimCacheIdReg.test(targetId) : false;

export default getNimCacheId;
